"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INCA_VARIABLE_FORMATTER_OPTION_TYPES = exports.INCA_VARIABLE_FORMATTER_TYPES = exports.INCA_VARIABLE_FUNCTION_TYPES = exports.INCA_VARIABLE_TYPES = void 0;
/**
 * Types of inca variables available.
 */
var INCA_VARIABLE_TYPES;
(function (INCA_VARIABLE_TYPES) {
    INCA_VARIABLE_TYPES["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    INCA_VARIABLE_TYPES["MULTI_CHOICE"] = "MULTI_CHOICE";
    INCA_VARIABLE_TYPES["RANKED_MULTI_CHOICE"] = "RANKED_MULTI_CHOICE";
    INCA_VARIABLE_TYPES["OPEN"] = "OPEN";
    INCA_VARIABLE_TYPES["NUMERIC"] = "NUMERIC";
    INCA_VARIABLE_TYPES["URL_METADATA"] = "URL_METADATA";
    INCA_VARIABLE_TYPES["SYSTEM_METADATA"] = "SYSTEM_METADATA";
    INCA_VARIABLE_TYPES["BASIC"] = "BASIC";
})(INCA_VARIABLE_TYPES = exports.INCA_VARIABLE_TYPES || (exports.INCA_VARIABLE_TYPES = {}));
/**
 * Types of logical functions available which may be evaluated on inca variables.
 */
var INCA_VARIABLE_FUNCTION_TYPES;
(function (INCA_VARIABLE_FUNCTION_TYPES) {
    // choice based questions
    INCA_VARIABLE_FUNCTION_TYPES["INCLUDES"] = "INCLUDES";
    INCA_VARIABLE_FUNCTION_TYPES["DOES_NOT_INCLUDE"] = "DOES_NOT_INCLUDE";
    INCA_VARIABLE_FUNCTION_TYPES["INCLUDES_WITH_RANK"] = "INCLUDES_WITH_RANK";
    INCA_VARIABLE_FUNCTION_TYPES["DOES_NOT_INCLUDE_RANK"] = "DOES_NOT_INCLUDE_RANK";
    INCA_VARIABLE_FUNCTION_TYPES["OPT_NUM_GREATER_THAN"] = "OPT_NUM_GREATER_THAN";
    INCA_VARIABLE_FUNCTION_TYPES["OPT_NUM_EQUALS_TO"] = "OPT_NUM_EQUALS_TO";
    INCA_VARIABLE_FUNCTION_TYPES["OPT_NUM_LESS_THAN"] = "OPT_NUM_LESS_THAN";
    // string based questions
    INCA_VARIABLE_FUNCTION_TYPES["STRING_CONTAINS"] = "STRING_CONTAINS";
    INCA_VARIABLE_FUNCTION_TYPES["STRING_DOES_NOT_CONTAIN"] = "STRING_DOES_NOT_CONTAIN";
    INCA_VARIABLE_FUNCTION_TYPES["STRING_EQUALS"] = "STRING_EQUALS";
    INCA_VARIABLE_FUNCTION_TYPES["STRING_DOES_NOT_EQUAL"] = "STRING_DOES_NOT_EQUAL";
    INCA_VARIABLE_FUNCTION_TYPES["STRING_LIKE"] = "STRING_LIKE";
    INCA_VARIABLE_FUNCTION_TYPES["STRING_MATCHES"] = "STRING_MATCHES";
    // numeric
    INCA_VARIABLE_FUNCTION_TYPES["NUM_GREATER_THAN"] = "NUM_GREATER_THAN";
    INCA_VARIABLE_FUNCTION_TYPES["NUM_GREATER_THAN_OR_EQUALS"] = "NUM_GREATER_THAN_OR_EQUALS";
    INCA_VARIABLE_FUNCTION_TYPES["NUM_LESS_THAN"] = "NUM_LESS_THAN";
    INCA_VARIABLE_FUNCTION_TYPES["NUM_LESS_THAN_OR_EQUALS"] = "NUM_LESS_THAN_OR_EQUALS";
    INCA_VARIABLE_FUNCTION_TYPES["NUM_EQUALS_TO"] = "NUM_EQUALS_TO";
    INCA_VARIABLE_FUNCTION_TYPES["NUM_DOES_NOT_EQUAL"] = "NUM_DOES_NOT_EQUAL";
    // question based
    INCA_VARIABLE_FUNCTION_TYPES["IS_DISPLAYED"] = "IS_DISPLAYED";
    INCA_VARIABLE_FUNCTION_TYPES["IS_NOT_DISPLAYED"] = "IS_NOT_DISPLAYED";
    // targets based
    INCA_VARIABLE_FUNCTION_TYPES["TARGETS_DETECTED"] = "TARGETS_DETECTED";
    INCA_VARIABLE_FUNCTION_TYPES["TARGETS_NOT_DETECTED"] = "TARGETS_NOT_DETECTED";
})(INCA_VARIABLE_FUNCTION_TYPES = exports.INCA_VARIABLE_FUNCTION_TYPES || (exports.INCA_VARIABLE_FUNCTION_TYPES = {}));
/**
 * Types of formatters available which may be applied to inca variables.
 */
var INCA_VARIABLE_FORMATTER_TYPES;
(function (INCA_VARIABLE_FORMATTER_TYPES) {
    INCA_VARIABLE_FORMATTER_TYPES["TYPE_FORMAT"] = "REFERENCE_TYPE_FORMAT";
    INCA_VARIABLE_FORMATTER_TYPES["TEXT_CASING"] = "REFERENCE_TEXT_CASING";
    INCA_VARIABLE_FORMATTER_TYPES["TEXT_TO_DISPLAY"] = "REFERENCE_TEXT_TO_DISPLAY";
    INCA_VARIABLE_FORMATTER_TYPES["MULTI_OPTION_DISPLAY"] = "REFERENCE_MULTI_DISPLAY";
    INCA_VARIABLE_FORMATTER_TYPES["OTHER_TEXT"] = "REFERENCE_OTHER_TEXT";
})(INCA_VARIABLE_FORMATTER_TYPES = exports.INCA_VARIABLE_FORMATTER_TYPES || (exports.INCA_VARIABLE_FORMATTER_TYPES = {}));
/**
 * Types of 'options' (i.e. settings) available for the various formatters
 * which may be applied to inca variables.
 */
var INCA_VARIABLE_FORMATTER_OPTION_TYPES;
(function (INCA_VARIABLE_FORMATTER_OPTION_TYPES) {
    // TEXT_FORMAT
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TYPE_FORMAT_TEXT"] = "TYPE_FORMAT_TEXT";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TYPE_FORMAT_IMAGE"] = "TYPE_FORMAT_IMAGE";
    // TEXT_CASING
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_CASING_NONE"] = "TEXT_CASING_NONE";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_CASING_UPPER_FIRST"] = "TEXT_CASING_UPPER_FIRST";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_CASING_UPPER_ALL"] = "TEXT_CASING_UPPER_ALL";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_CASING_LOWER_FIRST"] = "TEXT_CASING_LOWER_FIRST";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_CASING_LOWER_ALL"] = "TEXT_CASING_LOWER_ALL";
    // TEXT_TO_DISPLAY
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_TO_DISPLAY_TEXT"] = "TEXT_TO_DISPLAY_TEXT";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["TEXT_TO_DISPLAY_LABEL"] = "TEXT_TO_DISPLAY_LABEL";
    // MULTI_OPTION_DISPLAY
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["MULTI_OPTION_DISPLAY_ASC"] = "MULTI_OPTION_DISPLAY_ASC";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["MULTI_OPTION_DISPLAY_DESC"] = "MULTI_OPTION_DISPLAY_DESC";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["MULTI_OPTION_DISPLAY_RANK"] = "MULTI_OPTION_DISPLAY_RANK";
    // OTHER_TEXT
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["OTHER_TEXT_TEXT"] = "OTHER_TEXT_TEXT";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["OTHER_TEXT_LABEL"] = "OTHER_TEXT_LABEL";
    INCA_VARIABLE_FORMATTER_OPTION_TYPES["OTHER_TEXT_SPECIFY"] = "OTHER_TEXT_SPECIFY";
})(INCA_VARIABLE_FORMATTER_OPTION_TYPES = exports.INCA_VARIABLE_FORMATTER_OPTION_TYPES || (exports.INCA_VARIABLE_FORMATTER_OPTION_TYPES = {}));
//# sourceMappingURL=types.js.map